var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout"},[_c('h4',[_vm._v("\n    "+_vm._s(_vm.$t('pages.auth.logging_out'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }